// extracted by mini-css-extract-plugin
export default {"containerWrapper":"CardSellersContainer_containerWrapper__1yFXF","slider":"CardSellersContainer_slider__-c2hG","cardWrapper":"CardSellersContainer_cardWrapper__WDcXH"};